import React, { Component } from "react";
import Dialog from "../../../dialogs/dialog";
import DialogInput from "../../../dialogs/input";
import DialogUpload from "../../../dialogs/uploadfile";
import SimplePopup from "../../../../components/bases/popup/simplePopup";

import { apiCreateClients,apiDeleteClients, apiUpdateClients } from "../../../../utils/apis";
import { apiCreateDiffusors,apiDeleteDiffusors, apiUpdateDiffusors } from "../../../../utils/apis";



class ClientsDiffusorsForm extends Dialog
{
  constructor(props) 
  {
    super(props);
    this.state.title= {en:"Error !!!",  fr:"Erreur !!!",}

    this.state.msgname ="";
    this.state.msgmail="";
    this.state.formulaire ={};

    if (this.props.action != "add")
    {
        if (this.props.table == "CLIENTS")
        {
            
            this.state.formulaire.id = this.props.formulaire.clid;
            this.state.formulaire.idbase = this.props.formulaire.clidbase;
            this.state.formulaire.name = this.props.formulaire.clname;
            this.state.formulaire.contact = this.props.formulaire.clcontact;
            this.state.formulaire.mail = this.props.formulaire.clmail;
            this.state.formulaire.ad1 = this.props.formulaire.clad1;
            this.state.formulaire.ad2 = this.props.formulaire.clad2;
            this.state.formulaire.phone = this.props.formulaire.clphone;
            this.state.formulaire.image = this.props.formulaire.climage;

        }
        else
        {
          this.state.formulaire.id = this.props.formulaire.diid;
          this.state.formulaire.idbase = this.props.formulaire.diidbase;
          this.state.formulaire.name = this.props.formulaire.diname;
          this.state.formulaire.contact = this.props.formulaire.dicontact;
          this.state.formulaire.mail = this.props.formulaire.dimail;
          this.state.formulaire.ad1 = this.props.formulaire.diad1;
          this.state.formulaire.ad2 = this.props.formulaire.diad2;
          this.state.formulaire.phone = this.props.formulaire.diphone;
          this.state.formulaire.image = this.props.formulaire.diimage;



        } 
        this.state.displaydeletepopup = false;
        

    }


    switch (this.props.action)
    {
        case "add":
            this.state.title= this.props.table=="CLIENTS"? {en:"Add client",  fr:"Ajouter un client",}: {en:"Add diffusor",  fr:"Ajouter un diffuseur",}
            this.state.formulaire = {id:0,idbase:"",name:"",contact:"",mail:"",ad1:"",ad2:"",phone:"",image:""};
            break;
        case "edit":
            this.state.title= this.props.table=="CLIENTS"? {en:"Edit client",  fr:"Modifier un client",}: {en:"Edit diffusor",  fr:"Modifier un diffuseur",}
            break;
        case "delete":
            this.state.title= this.props.table=="CLIENTS"? {en:"Delete client",  fr:"Supprimer un client",}: {en:"Delete diffusor",  fr:"Supprimer un diffuseur",}
            break;
    }

    
    


    var buttons = [];

    buttons.push({type:"back", disabled:false});

    if (this.props.action != "delete")
      buttons.push({type:"ok", disabled:false});
    else
      buttons.push({type:"text", disabled:false,text:{fr:"Supprimer",en:"Delete"},key:"ok"})

    this.state.buttons = buttons;

    this.idbaseRef = React.createRef();
    this.nameRef = React.createRef();
    this.contactRef = React.createRef();
    this.mailRef = React.createRef();
    this.ad1Ref = React.createRef();
    this.ad2Ref = React.createRef();
    this.phoneRef = React.createRef();
    this.imageRef = React.createRef();
    

    this.handleButton =  this.handleButton.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.retourapi = this.retourapidelete.bind(this);
    this.retourapidelete = this.retourapi.bind(this)
    this.popupreturn = this.popupreturn.bind(this)
    this.onQuit = this.onQuit.bind(this)
  }
  checkvalidemail(cmail)
    {
        if (cmail=="") return true;
        if (!cmail.match(/[a-z0-9_\-\.]+@[a-z0-9_\-\.]+\.[a-z]+/i)) {
            return false;
        }        
        return true;
    }

    onQuit()
    {
      this.props.onvalidform({ret:false});
    }

    onValid()
    {
      
      this.handleButton("ok");
    }


    popupreturn()
    {
      this.setState({displaydeletepopup:false});

    }

    retourapidelete(ret)
    {
   
      console.log("RETOUR API DELETE ",ret)

      var retour = {};
      retour.action = this.props.action;
      retour.ok = ret.ret;


      if (ret.ret )
      {
        retour.id = ret.id;
        retour.msg = ret.msg;
        this.props.onvalidform(retour);
        return;
      }


      if (ret.msg == "inuse")
      {
          this.setState({displaydeletepopup:true});
          return;
      }
      else
        this.props.onvalidform(retour);


      
    }
  


  retourapi(ret)
  {
 

    console.log("RETOUR API PAS DELETE ",ret)
    var retour = {};
    retour.action = this.props.action;
    retour.ok = ret.ret;
    if (ret.ret )
    {
      retour.id = ret.id;
      retour.msg = ret.msg;
    }
    this.props.onvalidform(retour);
  }


  getApiFormulaire(formulaire)
  {
    var apiformulaire = {};

    if (this.props.table=="CLIENTS")
    {
        apiformulaire.clid = this.state.formulaire.id;
        apiformulaire.clidbase = formulaire.idbase;
        apiformulaire.clname = formulaire.name;
        apiformulaire.clcontact = formulaire.contact;
        apiformulaire.clad1 = formulaire.ad1;
        apiformulaire.clad2 = formulaire.ad2;
        apiformulaire.clphone = formulaire.phone;
        apiformulaire.clmail = formulaire.mail;
        apiformulaire.climage = formulaire.image;

        

    }
    else
    {
        apiformulaire.diid = this.state.formulaire.id;
        apiformulaire.diidbase = formulaire.idbase;
        apiformulaire.diname = formulaire.name;
        apiformulaire.dicontact = formulaire.contact;
        apiformulaire.diad1 = formulaire.ad1;
        apiformulaire.diad2 = formulaire.ad2;
        apiformulaire.diphone = formulaire.phone;
        apiformulaire.dimail = formulaire.mail;
        apiformulaire.diimage = formulaire.image;

    }
    return apiformulaire;    
  }

  handleButton(buttonkey)
  {
    

    switch(buttonkey)
    {
       case "ok":
          var formulaire = {};
          formulaire.id = 0;
          formulaire.idbase = this.idbaseRef.current.getValue();
          formulaire.name = this.nameRef.current.getValue();
          formulaire.contact = this.contactRef.current.getValue();
          formulaire.mail = this.mailRef.current.getValue();
          formulaire.ad1 = this.ad1Ref.current.getValue();
          formulaire.ad2 = this.ad2Ref.current.getValue();
          formulaire.phone = this.phoneRef.current.getValue();
          formulaire.image = this.imageRef.current.getValue();    

          
          var errname="";
          var errmail="";
          if (formulaire.name == "") errname=this.context.language=="fr"?"Zone obligatoire.":"Required field.";
          if (!this.checkvalidemail(formulaire.mail))
              errmail=this.context.language=="fr"?"Format mail non valide.":"Invalid Email address.";
          this.nameRef.current.setErrorMsg(errname);
          this.mailRef.current.setErrorMsg(errmail)

   
          
          if ((errname != "") || (errmail !="")) return;

          if (this.props.action == "add")
          {
            var apiformulaire = this.getApiFormulaire(formulaire);
            if (this.props.table=="CLIENTS")
              apiCreateClients(apiformulaire, this.retourapi);      
            else
            apiCreateDiffusors(apiformulaire, this.retourapi);      
          }
          
          if (this.props.action == "delete")
          {
            
            var apiformulaire = this.getApiFormulaire(formulaire);
            if (this.props.table=="CLIENTS")
              apiDeleteClients(apiformulaire, this.retourapidelete);      
            else
              apiDeleteDiffusors(apiformulaire, this.retourapidelete);      

          }

          if (this.props.action == "edit")
          {
            var apiformulaire = this.getApiFormulaire(formulaire);
            if (this.props.table=="CLIENTS")
              apiUpdateClients(apiformulaire, this.retourapi);      
            else
              apiUpdateDiffusors(apiformulaire, this.retourapi);      
          }
            

          break;
      case "back":
        this.onQuit();
        return;
    }

  }

  
  handleOnChange()
  {

  }

  render()
  {

    const disable = (this.props.action == "delete");
    const retour =
    (
      <>

      <SimplePopup
        display = {this.state.displaydeletepopup}
        title = {{"fr": "Suppression impossible.", "en": "Impossible to delete"}} 
        onCancel = {this.props.popupreturn}
        text = {
          this.props.table=="CLIENTS"?
          {"fr": "Ce client est utilisé dans dans autre projet.", "en": "This client is in use in another project"}
          :
          {"fr": "Ce diffuseur est utilisé dans dans autre projet.", "en": "This diffusor is in use in another project"}
        }

        buttons = {           
          [ {text:{"fr":"Ok","en":"Ok"}, onclick :this.popupreturn } ]
          }
        />

      <DialogInput
                value = {this.state.formulaire.idbase}
                disabled={true}
                onChange =  {this.handleOnChange}
                autoFocus = {false}
                ref = {this.idbaseRef}
                readOnly = {true}
                width = "400px"
                title = {this.context.language=="fr"?"ID Base":"Base ID"}
              />




     
      <DialogInput
                value = {this.state.formulaire.name}
                disabled={disable}
                autoFocus = {true}
                ref = {this.nameRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                errmsg={this.state.msgname}
                title = {this.context.language=="fr"?"Nom":"Name"}
              />


        <DialogInput
                value = {this.state.formulaire.contact}
                disabled={disable}
                autoFocus = {false}
                ref = {this.contactRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                title = {this.context.language=="fr"?"Contact":"Contact"}
              />

        <DialogInput
                value = {this.state.formulaire.mail}
                disabled={disable}
                autoFocus = {false}
                ref = {this.mailRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                errmsg = {this.state.msgmail}
                title = {this.context.language=="fr"?"Adresse Mail":"Mail Address"}
              />

        <DialogInput
                value = {this.state.formulaire.ad1}
                disabled={disable}
                autoFocus = {false}
                ref = {this.ad1Ref}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                title = {this.context.language=="fr"?"Adresse 1":"Address 1"}
              />

        <DialogInput
                value = {this.state.formulaire.ad2}
                disabled={disable}
                autoFocus = {false}
                ref = {this.ad2Ref}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                title = {this.context.language=="fr"?"Adresse 2":"Address 2"}
              />

        <DialogInput
                value = {this.state.formulaire.phone}
                disabled={disable}
                autoFocus = {false}
                ref = {this.phoneRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                title = {this.context.language=="fr"?"Téléphone":"Phone"}
              />

      <DialogUpload
        validFiles = {["png","jpg"]}
        ref = {this.imageRef}
        width = {120}
        disabled={disable}
        mode="image"
        image={this.state.formulaire.image}
        onChange =  {this.handleOnChange}
      />

      </>

    )

    return super.render(retour);
  }


}
ClientsDiffusorsForm.defaultProps = 
{
    table: "CLIENTS",
    selectButton: false,
    zindex:2,
    closebutton: true,
}




export default ClientsDiffusorsForm;